<template>
  <v-layout row wrap justify-center>
    <pg-detail
      :title="title"
      :primary_key="primary_key"
      :primary_field="primary_field"
      :deleteProcess="deleteDialog"
      :fab="profil.role == 'ADMIN' && $route.query.id != profil.id_user"
      @found="selected = [$event]"
      @add="openInputDialog('ADD')"
      @update="openInputDialog('UPDATE')"
      @delete="deleteDialog = true"
    >
      <template slot="detail-content" slot-scope="props">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-list two-line subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">person</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Username</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    props.detail.username
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-avatar class="viewer" v-viewer>
                  <img
                    v-lazy="c.PHOTO_PROFIL_URL + props.detail.photo_profil"
                    :alt="props.detail.username"
                  />
                </v-list-tile-avatar>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">mail</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>E-Mail</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    props.detail.email
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">gavel</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Role</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.role }}
                    <small>{{ props.detail.role_desc }}</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">access_time</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Aktivitas Terakhir</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    $moment(
                      props.detail.last_activity,
                      "YYYY-MM-DD HH:mm:ss",
                      true
                    ).isValid()
                      ? props.detail.last_activity
                      : "belum pernah" | moment("from", "now")
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">assignment_turned_in</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Total Training</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.total_training }}
                    <small>Training</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">flash_on</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Status</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <v-chip
                      v-if="parseInt(props.detail.active_user)"
                      color="green"
                      class="white--text"
                      label
                      >AKTIF</v-chip
                    >
                    <v-chip v-else color="red" class="white--text" label
                      >DIBLOKIR</v-chip
                    >
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
            </v-list>
          </v-flex>
          <v-flex xs12 sm6>
            <v-expansion-panel class="elevation-1" focusable>
              <v-expansion-panel-content :value="true">
                <div slot="header">TRAINING TERKAIT</div>
                <v-subheader v-if="!props.detail.training.length" class="mb-3">
                  {{ title }} ini tidak memiliki keterkaitan data dengan
                  TRAINING.
                </v-subheader>
                <vue-perfect-scrollbar v-else style="max-height: 400px">
                  <v-list two-line>
                    <v-list-tile
                      v-for="(item, i) in props.detail.training"
                      :key="i"
                      style="border-bottom: 1px solid #eee"
                      v-ripple
                      :to="{
                        name: 'TrainingList',
                        query: { id: item.id_training }
                      }"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.materi }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          item.waktu_mulai | moment("from", "now")
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </vue-perfect-scrollbar>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                <div slot="header">MATERI TERKAIT</div>
                <v-subheader v-if="!detailMateri" class="mb-3">
                  {{ title }} ini tidak memiliki keterkaitan data dengan MATERI.
                </v-subheader>
                <vue-perfect-scrollbar v-else style="max-height: 400px">
                  <v-list two-line>
                    <v-list-tile
                      v-for="(item, i) in detailMateri"
                      :key="i"
                      style="border-bottom: 1px solid #eee"
                      v-ripple
                      :to="{ name: 'Materi', query: { id: item.id_materi } }"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.materi }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          item.tujuan | noEmpty
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </vue-perfect-scrollbar>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </template>
    </pg-detail>

    <template v-if="!$route.query.id">
      <v-flex xs12>
        <v-card>
          <v-card-title class="py-2">
            <v-btn color="green" dark icon @click.stop="openInputDialog('ADD')">
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              color="blue"
              :disabled="selected.length != 1"
              dark
              icon
              @click.stop="openInputDialog('UPDATE')"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              color="red"
              :disabled="selected.length == 0"
              dark
              icon
              @click.stop="deleteDialog = true"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <json-excel
              :data="selected"
              :export-fields="jsonFields"
              :name="`${$route.name}.xls`"
            >
              <v-btn color="indigo" :disabled="selected.length == 0" dark icon>
                <v-icon>file_download</v-icon>
              </v-btn>
            </json-excel>
            <v-btn
              :color="!filterOn ? 'grey' : 'orange'"
              :disabled="!sourceData.length && !filterOn"
              dark
              icon
              @click.stop="filterDialog = true"
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Pencarian"
              clearable
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            v-if="!$vuetify.breakpoint.xs"
            v-model="selected"
            :headers="headers"
            :items="sourceData"
            :search="search"
            :pagination.sync="pagination"
            :loading="!user_loaded"
            select-all
            item-key="id_user"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            class="elevation-1"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.native="toggleAll"
                  >
                  </v-checkbox>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable pa-0 text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                    header.align ? `text-xs-${header.align}` : 'text-xs-left'
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <v-progress-linear
              slot="progress"
              color="primary"
              :height="3"
              indeterminate
            >
            </v-progress-linear>
            <template slot="items" slot-scope="props">
              <tr
                :active="props.selected"
                class="nowrap"
                :class="{ 'red lighten-4': !parseInt(props.item.active_user) }"
                @click="toggleExpand(props)"
              >
                <td style="width: 80px">
                  <v-checkbox
                    :input-value="props.selected"
                    @click.stop="props.selected = !props.selected"
                    primary
                    hide-details
                  >
                  </v-checkbox>
                </td>
                <td>
                  <v-avatar :size="40" @click.stop="" class="viewer" v-viewer>
                    <img
                      v-lazy="c.PHOTO_PROFIL_URL + props.item.photo_profil"
                      :alt="props.item.username"
                      :key="props.item.id_user"
                    />
                  </v-avatar>
                  <v-chip
                    small
                    label
                    @click.stop="
                      $router.push({
                        name: $route.name,
                        query: { id: props.item.id_user }
                      })
                    "
                  >
                    {{ props.item.username }}
                  </v-chip>
                </td>
                <td>{{ props.item.email | noEmpty }}</td>
                <td>{{ props.item.role }}</td>
                <td>
                  {{
                    $moment(
                      props.item.last_activity,
                      "YYYY-MM-DD HH:mm:ss",
                      true
                    ).isValid()
                      ? props.item.last_activity
                      : "belum pernah" | moment("from", "now")
                  }}
                </td>
                <td class="text-xs-center">{{ props.item.total_training }}</td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card
                flat
                :color="$vuetify.dark ? 'grey darken-1' : 'grey lighten-5'"
              >
                <table class="expanded">
                  <tr v-for="(header, i) in headers" :key="`rows-${i}`">
                    <td>{{ header.text }}</td>
                    <td v-if="header.value == 'last_activity'">
                      {{
                        $moment(
                          props.item.last_activity,
                          "YYYY-MM-DD HH:mm:ss",
                          true
                        ).isValid()
                          ? props.item.last_activity
                          : "belum pernah" | moment("from", "now")
                      }}
                    </td>
                    <td v-else>{{ props.item[header.value] | noEmpty }}</td>
                  </tr>
                </table>
              </v-card>
            </template>
            <template slot="no-data">
              <v-alert
                :value="true"
                :color="user_loaded ? 'warning' : 'info'"
                :icon="user_loaded ? 'warning' : 'info'"
                class="pa-1"
              >
                <span v-if="!user_loaded">Mengambil data...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-table>

          <v-data-iterator
            v-else
            v-model="selected"
            :items="sourceData"
            :pagination.sync="pagination"
            :loading="!user_loaded"
            :search="search"
            select-all
            item-key="id_user"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            row
            wrap
          >
            <v-flex slot="item" slot-scope="props" xs12>
              <v-card
                :class="{ 'red lighten-4': !parseInt(props.item.active_user) }"
              >
                <v-card-media :height="200">
                  <img
                    :key="props.item.username"
                    style="width: 100%; margin: auto"
                    v-viewer
                    v-lazy="c.PHOTO_PROFIL_URL + props.item.photo_profil"
                    :alt="`Photo-${props.item.username}`"
                  />
                </v-card-media>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-checkbox
                      :input-value="props.selected"
                      @click.stop="props.selected = !props.selected"
                      class="ma-0 pa-0"
                      hide-details
                      primary
                    >
                    </v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      props.item.username
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :to="{
                        name: $route.name,
                        query: { id: props.item.id_user }
                      }"
                      fab
                      flat
                      small
                      color="primary"
                    >
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-slide-y-transition>
                  <!-- <div v-show="props.selected"> -->
                  <v-list
                    dense
                    :class="props.selected ? 'secondary white--text' : ''"
                  >
                    <v-list-tile v-for="(header, i) in simpleHeaders" :key="i">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ header.text }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          v-if="header.value == 'last_activity'"
                          >{{
                            $moment(
                              props.item.last_activity,
                              "YYYY-MM-DD HH:mm:ss",
                              true
                            ).isValid()
                              ? props.item.last_activity
                              : "belum pernah" | moment("from", "now")
                          }}</v-list-tile-sub-title
                        >
                        <v-list-tile-sub-title v-else>{{
                          props.item[header.value] | noEmpty
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <!-- </div> -->
                </v-slide-y-transition>
              </v-card>
            </v-flex>
            <template slot="no-data">
              <v-alert
                :value="true"
                color="warning"
                icon="warning"
                class="pa-1"
              >
                <span v-if="status.loading">Loading...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-iterator>
        </v-card>
      </v-flex>

      <pg-form-filter
        :dialog="filterDialog"
        :filterOn="filterOn"
        :filter="filter"
        :source="sourceData"
        :sourceOriginal="sourceOriginal"
        :title="title"
        @close="filterDialog = false"
        @toggle="
          filterOn = !filterOn;
          filterDialog = false;
        "
        @filtered="filterSource = $event"
      >
        <template slot="filter-content" slot-scope="props">
          <v-autocomplete
            append-icon="person_outline"
            attach
            hide-details
            item-text="username"
            item-value="id_user"
            :items="user"
            multiple
            v-model="props.filter.id_user"
            label="User"
          >
            <template slot="item" slot-scope="data">
              <v-list-tile-avatar>
                <img
                  v-lazy="c.PHOTO_PROFIL_URL + data.item.photo_profil"
                  :alt="data.item.username"
                />
              </v-list-tile-avatar>
              <v-list-tile-content
                :class="{ 'red--text': !parseInt(data.item.active_user) }"
              >
                <v-list-tile-title>{{ data.item.username }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.role
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-text-field
            append-icon="mail"
            hide-details
            type="text"
            v-model="props.filter.email"
            label="E-Mail"
          >
          </v-text-field>
          <v-autocomplete
            append-icon="gavel"
            attach
            hide-details
            item-text="role"
            item-value="id_role"
            :items="role"
            multiple
            v-model="props.filter.id_role"
            label="Role"
          >
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title>{{ data.item.role }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.role_desc
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-autocomplete
            append-icon="flash_on"
            attach
            hide-details
            item-text="val"
            item-value="key"
            :items="props.filter.field.active_user"
            multiple
            v-model="props.filter.active_user"
            label="Status"
          >
          </v-autocomplete>
          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-datetime-picker
                  appendIcon="today"
                  hideDetails
                  locale="id-id"
                  label="Aktivitas Terakhir"
                  :min="
                    $moment(props.filter.field.last_activity[0]).format(
                      'YYYY-MM-DD'
                    )
                  "
                  :max="
                    $moment(props.filter.last_activity[1]).format('YYYY-MM-DD')
                  "
                  v-model="props.filter.last_activity[0]"
                >
                </v-datetime-picker>
              </v-flex>
              <v-flex xs12 sm6>
                <v-datetime-picker
                  appendIcon="today"
                  hideDetails
                  locale="id-id"
                  :min="
                    $moment(props.filter.last_activity[0]).format('YYYY-MM-DD')
                  "
                  :max="
                    $moment(props.filter.field.last_activity[1]).format(
                      'YYYY-MM-DD'
                    )
                  "
                  v-model="props.filter.last_activity[1]"
                >
                </v-datetime-picker>
              </v-flex>
            </v-layout>
          </v-container>
          <v-range-slider
            v-model="props.filter.total_training"
            label="Total Training"
            append-icon="assignment_turned_in"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_training[0]"
            :max="props.filter.field.total_training[1]"
            thumb-label="always"
          >
          </v-range-slider>
        </template>
      </pg-form-filter>
    </template>

    <pg-form-delete
      :dialog="deleteDialog"
      :selected="selected"
      :title="title"
      :primary_key="primary_key"
      @cancel="deleteDialog = false"
      @deleted="onDeleted"
      action="user/DELETE_USER"
    >
      <template slot="item-detail" slot-scope="props">
        {{ props.item.username }} - {{ props.item.role }}
      </template>
    </pg-form-delete>

    <user-input
      :dialog="inputDialog"
      :data="selected[0]"
      :title="title"
      :action="inputAction"
      :primary_key="primary_key"
      :primary_field="primary_field"
      :width="700"
      @cancel="inputDialog = false"
      @submitted="onSubmitted"
    >
    </user-input>
  </v-layout>
</template>


<script>
import _ from "lodash";
import c from "@/constants";
import JsonExcel from "vue-json-excel";
import PgDetail from "@/components/private/PgDetail";
import PgFormDelete from "@/components/private/PgFormDelete";
import PgFormFilter from "@/components/private/PgFormFilter";
import UserInput from "@/components/pages/input/UserInput";
import VDatetimePicker from "@/components/widgets/input/DatetimePicker";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState } from "vuex";

const defaultFilter = {
  id_user: [],
  email: "",
  id_role: [],
  last_activity: ["", ""],
  total_training: [0, 100],
  active_user: [],
  field: {
    last_activity: ["", ""],
    total_training: [0, 100],
    active_user: [{ key: "1", val: "AKTIF" }, { key: "0", val: "BLOKIR" }]
  },
  format: {
    id_user: c.FORMAT.options,
    email: c.FORMAT.text,
    id_role: c.FORMAT.options,
    last_activity: c.FORMAT.datetime,
    total_training: c.FORMAT.number,
    active_user: c.FORMAT.text_options
  }
};

export default {
  name: "user",
  components: {
    JsonExcel,
    VuePerfectScrollbar,
    VDatetimePicker,
    PgDetail,
    PgFormDelete,
    PgFormFilter,
    UserInput
  },
  data() {
    return {
      // datatable
      headers: [
        { text: "USERNAME", value: "username" },
        { text: "EMAIL", value: "email" },
        { text: "ROLE", value: "role" },
        { text: "AKTIVITAS TERAKHIR", value: "last_activity" },
        { text: "TOTAL TRAINING", value: "total_training" }
      ],
      pagination: {
        sortBy: "username"
      },
      pages: [7, 10, 25, { text: "Semua", value: -1 }],
      selected: [],
      search: "",
      // dialog
      title: "USER",
      primary_field: "user",
      primary_key: "id_user",
      // delete
      deleteDialog: false,
      // filter
      filterDialog: false,
      filterSource: [],
      filterOn: false,
      filterHelperSourceUpdated: false,
      filter: _.cloneDeep(defaultFilter),
      // input
      inputDialog: false,
      inputAction: "ADD",
      // other
      c: c
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("auth", ["profil"]),
    ...mapState("user", ["user", "role", "user_loaded"]),
    simpleHeaders() {
      return this.headers.filter(h => !["username"].includes(h.value));
    },
    jsonFields() {
      return this.headers.reduce(
        (obj, item) => ((obj[item.text] = item.value), obj),
        {}
      );
    },
    detailMateri() {
      let result = null;
      if (this.$route.query.id) {
        let materi = this.$store.state.materi.materi.filter(c => {
          return c.id_user == this.$route.query.id;
        });
        if (materi.length) result = materi;
      }
      return result;
    },
    sourceOriginal() {
      /* eslint-disable */
      this.filterHelperSourceUpdated = true;
      return _.cloneDeep(this.$store.getters["user/userByPeriode"]);
    },
    sourceData() {
      let source = _.cloneDeep(this.sourceOriginal);
      if (
        (this.filterOn && !_.isEqual(source, this.filterSource)) ||
        (this.filterHelperSourceUpdated && this.filterSource.length)
      ) {
        source = this.filterSource;
        /* eslint-disable */
        this.filterHelperSourceUpdated = false;
      }
      return source;
    }
  },
  methods: {
    toggleAll() {
      if (this.selected.length == this.sourceData.length) this.selected = [];
      else this.selected = _.cloneDeep(this.sourceData);
    },
    toggleExpand(props) {
      if (this.$vuetify.breakpoint.smAndDown) {
        if (!props.selected) props.expanded = !props.expanded;
        else props.expanded = false;
      } else props.expanded = false;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    openInputDialog(action) {
      this.inputAction = action;
      this.inputDialog = true;
    },
    onSubmitted(new_id) {
      this.inputDialog = false;
      if (!this.$route.query.id) {
        if (this.inputAction == "UPDATE") {
          setTimeout(() => {
            this.selected = [];
          }, 1000);
        }
      } else {
        if (this.inputAction == "ADD") {
          this.$router.push({
            name: this.$route.name,
            query: { id: new_id }
          });
        }
      }
    },
    onDeleted(selected) {
      this.selected = selected;
      // if all success, then close dialog
      if (!this.selected.length) this.deleteDialog = false;
    }
  },
  mounted() {}
};
</script>

<style scoped>
.thumbnail {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
}
.thumbnail img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.thumbnail img.portrait {
  width: 100%;
  height: auto;
}
</style>
